import { jsx as _jsx } from "react/jsx-runtime";
import { useDndContext } from "@dnd-kit/core";
import { memo, useEffect, useRef } from "react";
import { AutoSizer } from "react-virtualized";
import { VariableSizeList } from "react-window";
import { useKanbanFetchPageContext } from "~/components/KanbanView/KanbanColumnsManagers/shared/KanbanFetchPageContext";
import { visibleCustomFieldsLengthSelector } from "~/store/configViews/selectors";
import { kanbanColumnItemsSelector } from "~/store/kanbanManager/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
import { useRenderKanbanItem } from "./useRenderKanbanItem";
export const KanbanColumnItems = /*#__PURE__*/ memo((param)=>{
    let { kanbanColumnId } = param;
    const { isFetchingNextPage, fetchNextPage, hasNextPage } = useKanbanFetchPageContext();
    const { renderKanbanItem, getItemKey, getItemSize } = useRenderKanbanItem({
        kanbanColumnId,
        fetchNextPage,
        isFetchingNextPage
    });
    const { over } = useDndContext();
    const kanbanItems = useAirSelector((state)=>kanbanColumnItemsSelector(state, kanbanColumnId));
    const visibleCustomFieldsLength = useAirSelector(visibleCustomFieldsLengthSelector);
    const listRef = useRef(null);
    useEffect(()=>{
        var // redraw heights of list
        // may need to change if things get resorted
        _listRef_current;
        (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.resetAfterIndex(0);
    }, [
        over,
        visibleCustomFieldsLength,
        kanbanItems,
        kanbanColumnId
    ]);
    if (kanbanItems.length === 0) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "grow",
        children: /*#__PURE__*/ _jsx(AutoSizer, {
            children: (param)=>{
                let { height, width } = param;
                return /*#__PURE__*/ _jsx(VariableSizeList, {
                    className: "no-scrollbar box-border",
                    ref: listRef,
                    "data-testid": "var-size-list",
                    itemKey: getItemKey,
                    height: height,
                    itemCount: hasNextPage ? kanbanItems.length + 1 : kanbanItems.length,
                    itemSize: getItemSize,
                    width: width,
                    children: renderKanbanItem
                });
            }
        })
    });
});
KanbanColumnItems.displayName = "KanbanColumnItems";
